import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

// Page-local UI state for the SavedSearchView page. Mirrors advancedSearchSlice's
// shape (applyNonce + page/take) but kept separate so navigating between
// /advanced-search and a saved view doesn't bleed state across pages.

export const SAVED_SEARCH_VIEW_REDUCER_NAME = "saved-search-view";

const initialState = {
  applyNonce: 0,
  page: 0,
  take: 20,
};

const savedSearchViewSlice = createSlice({
  name: SAVED_SEARCH_VIEW_REDUCER_NAME,
  initialState,
  reducers: {
    triggerSavedSearchRun: (state) => {
      state.applyNonce += 1;
      state.page = 0;
    },
    setSavedSearchPage: (state, { payload }) => {
      state.page = payload;
    },
    setSavedSearchTake: (state, { payload }) => {
      state.take = payload;
      state.page = 0;
    },
    clearSavedSearchView: () => ({ ...initialState }),
  },
});

export const {
  triggerSavedSearchRun,
  setSavedSearchPage,
  setSavedSearchTake,
  clearSavedSearchView,
} = savedSearchViewSlice.actions;

export default savedSearchViewSlice.reducer;

export const useSelectSavedSearchApplyNonce = () =>
  useSelector((s) => s[SAVED_SEARCH_VIEW_REDUCER_NAME].applyNonce);

export const useSelectSavedSearchPage = () =>
  useSelector((s) => s[SAVED_SEARCH_VIEW_REDUCER_NAME].page);

export const useSelectSavedSearchTake = () =>
  useSelector((s) => s[SAVED_SEARCH_VIEW_REDUCER_NAME].take);
